export default __webpack_public_path__ + "static/birds-dc34f1ff77d031e49382799287323d01.png";